// extracted by mini-css-extract-plugin
export default {"circular-progress":"ProgressCircle_circular-progress__Weaw0","bg":"ProgressCircle_bg__KhY+G","fg":"ProgressCircle_fg__FdnIY"};